import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMaster4E: IAbstractModule = {
  type: IModuleType.masterZ4,
  name: 'Z Master 4 E (21-24)',
  hasScreen: true,
  columns: [
    [
      {
        name: "1",
        connector: "21",
        cell_size_id: 2,
        accessible: true,
      },
      {
        name: "2",
        connector: "22",
        cell_size_id: 2,
        accessible: true,
      },
      {
        name: "3",
        connector: "23",
        cell_size_id: 2,
        accessible: true,
      },
      {
        name: "4",
        connector: "24",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
